/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiagnoseSurveyTakerCto } from '../../models/diagnose-survey-taker-cto';
import { DiagnoseSurveyTakerEmailUpdateCto } from '../../models/diagnose-survey-taker-email-update-cto';

export interface UpdateTakerEmailAsync$Plain$Params {
  companyGuid: string;
  documentId: string;
      body?: DiagnoseSurveyTakerEmailUpdateCto
}

export function updateTakerEmailAsync$Plain(http: HttpClient, rootUrl: string, params: UpdateTakerEmailAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DiagnoseSurveyTakerCto>> {
  const rb = new RequestBuilder(rootUrl, updateTakerEmailAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.path('documentId', params.documentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiagnoseSurveyTakerCto>;
    })
  );
}

updateTakerEmailAsync$Plain.PATH = '/diagnose/xp-survey-actions/company/{companyGuid}/takers/{documentId}/email';
